import { useCallback, useRef } from 'react';

/**
 * Only the newest load may write state: a slower earlier request (range, filter
 * or page change) must not overwrite the newer one or drop its spinner.
 * `begin()` supersedes every earlier call; the returned `isCurrent()` is true
 * only until the next `begin()`.
 */
export function useLatestRequest(): () => () => boolean {
  const latestId = useRef(0);
  return useCallback(() => {
    const id = ++latestId.current;
    return () => id === latestId.current;
  }, []);
}
